import { reject, join, isEmpty, trim } from 'lodash/fp';

export default (data = {}, isTwoLines = false, showCounty = true) => {
  const {
    mailing_address: streetAddress,
    mailing_apartment: apartment,
    mailing_city: city,
    mailing_county: county,
    mailing_state: state,
    mailing_zipcode: zipcode
  } = data;
  const addressLine = apartment
    ? `${streetAddress} #${apartment}`
    : streetAddress;

  const arrAddress = showCounty ? [city, county, state] : [city, state];
  const cityCountyState = join(', ', reject(isEmpty, arrAddress));

  if (isTwoLines)
    return {
      line1: trim(addressLine),
      line2: trim(`${cityCountyState} ${zipcode || ''}`)
    };

  return `${
    addressLine ? `${addressLine}, ` : ''
  } ${cityCountyState} ${zipcode || ''}`;
};
